import { Main } from 'pages/main'
import { logger } from 'utils/system/logger'

const page = new Main()
page.init().catch((err) => logger('error', err))
